/**
 * This module manages UI state locally (no API)
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
// import Vue from 'vue'
import router from '@/router'

import {
	VUEX_UI_SHOW_NAVIGATION_DRAWER,
	VUEX_UI_HIDE_NAVIGATION_DRAWER,
	VUEX_UI_SHOW_LEFT_DRAWER,
	VUEX_UI_HIDE_LEFT_DRAWER,
	VUEX_UI_SHOW_RIGHT_DRAWER,
	VUEX_UI_HIDE_RIGHT_DRAWER,
    VUEX_UI_SHOW_ABSENCES_FILTER,
    VUEX_UI_HIDE_ABSENCES_FILTER,
	VUEX_UI_SHOW_JOB_FILTER,
	VUEX_UI_HIDE_JOB_FILTER,
	VUEX_UI_SHOW_JOB_SEARCH,
	VUEX_UI_HIDE_JOB_SEARCH,
	VUEX_UI_SHOW_JOB_CREATE,
	VUEX_UI_HIDE_JOB_CREATE,
	VUEX_UI_SHOW_OVERLAY,
	VUEX_UI_HIDE_OVERLAY,
	VUEX_UI_HIDE_ALL,
	VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY,
	VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY,
	VUEX_UI_SHOW_USER_FILTER,
	VUEX_UI_HIDE_USER_FILTER,
	VUEX_UI_SHOW_USER_OVERLAY,
	VUEX_UI_HIDE_USER_OVERLAY,
	VUEX_UI_SHOW_USER_SEARCH,
	VUEX_UI_HIDE_USER_SEARCH,
	VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE,
	VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY,
	VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY,
	VUEX_UI_NAV_CHILDREN_OPEN,
	VUEX_UI_SHOW_QUICK_FILTER_OVERLAY,
	VUEX_UI_HIDE_QUICK_FILTER_OVERLAY,
	VUEX_UI_SHOW_GLOBAL_UPLOADER,
	VUEX_UI_HIDE_GLOBAL_UPLOADER,
	VUEX_UI_OPEN_GLOBAL_UPLOADER,
	VUEX_UI_CLOSE_GLOBAL_UPLOADER,
	VUEX_UI_HIDE_JOB_SEARCH_MOBILE,
	VUEX_UI_SHOW_JOB_SEARCH_MOBILE,
    VUEX_UI_HIDE_USER_SEARCH_MOBILE,
	VUEX_UI_SHOW_USER_SEARCH_MOBILE,
	VUEX_UI_SET_PREVIEW_OPEN_STATUS,
	VUEX_UI_CLEAR_ALL_PREVIEW_OPEN_STATUSES,
	VUEX_UI_SHOW_MOBILE_DRAWER_RIGHT,
	VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT,
	VUEX_UI_SHOW_JOB_PRINT_OVERLAY,
	VUEX_UI_HIDE_JOB_PRINT_OVERLAY,
    VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY,
	VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT,
	VUEX_UI_SHOW_EMAIL_ALL_OVERLAY,
	VUEX_UI_HIDE_EMAIL_ALL_OVERLAY,
    VUEX_UI_SEND_EMAIL_ALL
	} from '@/store/constants/ui'

import {
	VUEX_AUTH_LOGOUT
	} from '@/store/constants/auth'

import {
	VUEX_ROUTING_ENTER_JOBS,
	VUEX_ROUTING_ENTER_JOB,
	VUEX_ROUTING_EXIT_JOB,
    VUEX_ROUTING_EXIT_JOBS,
	VUEX_ROUTING_ENTER_REQUESTS,
	VUEX_ROUTING_ENTER_CALENDAR_ITEMS,
	VUEX_ROUTING_ENTER_CALENDAR_ITEM,
	VUEX_ROUTING_EXIT_CALENDAR_ITEM,
	VUEX_ROUTING_ENTER_MEMOS,
	VUEX_ROUTING_ENTER_MEMO,
	VUEX_ROUTING_EXIT_MEMO,
	VUEX_ROUTING_ENTER_DOCS,
	VUEX_ROUTING_ENTER_DOC,
	VUEX_ROUTING_EXIT_DOC,
	VUEX_ROUTING_ENTER_EVENTS,
	VUEX_ROUTING_ENTER_EVENT,
	VUEX_ROUTING_EXIT_EVENT,
	VUEX_ROUTING_ENTER_UNAUTHENTICATED_ROUTE,
	VUEX_ROUTING_ENTER_AUTHENTICATED_ROUTE
	} from '@/store/constants/routing'

import {
	VUEX_JOB_CREATE_INIT,
	VUEX_JOB_CREATE_UI,
	VUEX_JOB_CREATE_CANCEL
	} from '@/store/constants/jobs'

import {
	VUEX_ATTACHMENT_QUEUE_MANAGER_INIT_JOB_ATTACHMENT
	} from '@/store/constants/attachment_queue_manager'

import { 
	VUEX_CALENDAR_ITEM_CREATE_INIT,
	VUEX_CALENDAR_ITEM_CREATE_UPDATE,
	VUEX_CALENDAR_ITEM_CREATE_CANCEL,
	VUEX_CALENDAR_ITEM_MOBILE_DRAWER_INIT
	} from '@/store/constants/calendarItems'

import {
	VUEX_MEMO_CREATE_INIT,
	VUEX_MEMO_CREATE_UPDATE,
	VUEX_MEMO_CREATE_CANCEL
	} from '@/store/constants/memos'

import {
	VUEX_DOC_CREATE_INIT,
	VUEX_DOC_CREATE_UPDATE,
	VUEX_DOC_CREATE_CANCEL
	} from '@/store/constants/docs'

import {
	VUEX_EVENT_CREATE_INIT,
	VUEX_EVENT_CREATE_UPDATE,
	VUEX_EVENT_CREATE_CANCEL
	} from '@/store/constants/events'

import {
    VUEX_ONBOARDING_UPDATE_PROP_EMAIL_RESET,
} from '@/store/constants/onboarding'

import api from '@/api'

import {
    VUEX_SNACKBAR_SHOW,
} from '@/store/constants/snackbar'

const state = {
	navigationDrawer: {
		vuetifyDrawerState: true,
		openState: false
	},
	notificationsDrawer: {
		notificationSettingsOpenState: false
	},
	leftDrawer: {
		openState: false,
		content: null
	},
	rightDrawer: {
		openState: false,
		content: null,
		isFixed: false,
	},
    absencesFilterOverlay: {
        openState: false,
        content: null
    },
	jobFilterOverlay: {
		openState: false,
		content: null
	},
	emailAllOverlay: {
		openState: false
	},
	userSearchOverlay: {
		openState: false
	},
    userSearchMobileOverlay: {
        openState: false
    },
	userFilterOverlay: {
		openState: false
	},
	userOverlay: {
		openState: false,
	},
	onboardingOverlay: {
		openState: false,
        isRequestSuccessConfirmation:false,
	},
	jobSearchOverlay: {
		openState: false,
		content: null
	},
	jobSearchMobileOverlay: {
		openState: false
	},
	jobCreateOverlay: {
		openState: false,
		isShowingConfirmation: false,
	},
	calendarCreateOverlay: {
		openState: false,
		content: null
	},
	memoCreateOverlay: {
		openState: false,
		content: null
	},
	docCreateOverlay: {
		openState: false,
		content:null
	},
	eventCreateOverlay: {
		openState: false,
		content: null
	},
	resetPasswordOverlay: {
		openState: false,
	},
	overlay: {
		openState: false,
		content: null,
		options: null
	},
	overlayMask: {
		openState: false
	},
	streamCommentEditor: {
		openState: false
	},
	mobileChild: {
		childrenOpen: false,
		selected: null
	},
	quickFilterOverlay: {
		openState: false
	},
	globalUploader: {
		displayState: false,
		openState: false
	},
	mobileDrawerRight: {
		openState: false,
		content: null
	},
	previewOpenStatusList: {},

	jobPrintOverlay: {
		openState: false,
        errorMessage: '',
	}
}


const getters = { }

const actions =  {
	// -- Hide ALL Drawers & Overlays
	[VUEX_UI_HIDE_ALL]: ({ commit }) => {
		commit(VUEX_UI_HIDE_ALL)
	},
	
	[VUEX_UI_SHOW_EMAIL_ALL_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_SHOW_EMAIL_ALL_OVERLAY)
	},

	[VUEX_UI_HIDE_EMAIL_ALL_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_HIDE_EMAIL_ALL_OVERLAY)
	},
    [VUEX_UI_SEND_EMAIL_ALL]: ({commit, dispatch}, payload) => {
        let formData = payload.formData

        api.post('mail/users/active',
            formData
        ).then((response) => {
            dispatch(VUEX_UI_HIDE_EMAIL_ALL_OVERLAY)

            dispatch(VUEX_SNACKBAR_SHOW, {
                description_text: "Success! Your email has been sent.",
                button_text: "",
                timeout: 4000,
                button_dispatch: "",
                button_dispatch_payload: {},
            })
        }).catch((err) => {
            //alert(`There was an error: ${err.message}`)
            //Show snackbar for success
            dispatch(VUEX_SNACKBAR_SHOW, {
                description_text: "Error! " + err.message,
                button_text: "",
                timeout: 4000,
                button_dispatch: "",
                button_dispatch_payload: {},
            })
            console.error('Email send failure',err)
        });
    },


	[VUEX_UI_SHOW_NAVIGATION_DRAWER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_NAVIGATION_DRAWER)
	},

	[VUEX_UI_HIDE_NAVIGATION_DRAWER]: ({ commit }) => {
		commit(VUEX_UI_HIDE_NAVIGATION_DRAWER)
	},

	[VUEX_UI_SHOW_LEFT_DRAWER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_LEFT_DRAWER)
	},

	[VUEX_UI_HIDE_LEFT_DRAWER]: ({ commit }) => {
		commit(VUEX_UI_HIDE_LEFT_DRAWER)
	},

	[VUEX_UI_SHOW_RIGHT_DRAWER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_RIGHT_DRAWER)
	},

	[VUEX_UI_HIDE_RIGHT_DRAWER]: ({ commit }) => {
		let route = router.history.current.name
        commit(VUEX_UI_HIDE_RIGHT_DRAWER)

		switch(route) {
			case 'absences-notice' :
				router.replace({ name: 'department-absences', params:{ reload:false } })
				break
		}
	},

	[VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT]: ({ commit }) => {
		let route = router.history.current.name
        commit(VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT)

		switch(route) {
			case 'absences-notice' :
				router.replace({ name: 'department-absences', params:{ reload:false } })
				break
		}
	},

    [VUEX_UI_SHOW_ABSENCES_FILTER]: ({ commit }) => {
        commit(VUEX_UI_SHOW_ABSENCES_FILTER)
    },

    [VUEX_UI_HIDE_ABSENCES_FILTER]: ({ commit }) => {
        commit(VUEX_UI_HIDE_ABSENCES_FILTER)
    },

	[VUEX_UI_SHOW_JOB_FILTER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_JOB_FILTER)
	},

	[VUEX_UI_HIDE_JOB_FILTER]: ({ commit }) => {
		commit(VUEX_UI_HIDE_JOB_FILTER)
	},

	[VUEX_UI_SHOW_JOB_SEARCH]: ({ commit }) => {
		commit(VUEX_UI_SHOW_JOB_SEARCH)
	},

	[VUEX_UI_HIDE_JOB_SEARCH]: ({ commit }) => {
		commit(VUEX_UI_HIDE_JOB_SEARCH)
	},

	[VUEX_UI_SHOW_USER_FILTER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_USER_FILTER)
	},

	[VUEX_UI_HIDE_USER_FILTER]: ({ commit }) => {
		commit(VUEX_UI_HIDE_USER_FILTER)
	},

	[VUEX_UI_SHOW_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_SHOW_OVERLAY)
	},

	[VUEX_UI_HIDE_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_HIDE_OVERLAY)
	},

	[VUEX_UI_SHOW_USER_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_SHOW_USER_OVERLAY)
	},

	[VUEX_UI_HIDE_USER_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_HIDE_USER_OVERLAY)
	},

	[VUEX_UI_SHOW_USER_SEARCH]: ({ commit }) => {
		commit(VUEX_UI_SHOW_USER_SEARCH)
	},

	[VUEX_UI_HIDE_USER_SEARCH]: ({ commit }) => {
		commit(VUEX_UI_HIDE_USER_SEARCH)
	},

    [VUEX_UI_SHOW_USER_SEARCH_MOBILE]: ({ commit }) => {
        commit(VUEX_UI_SHOW_USER_SEARCH_MOBILE)
    },

    [VUEX_UI_HIDE_USER_SEARCH_MOBILE]: ({ commit }) => {
        commit(VUEX_UI_HIDE_USER_SEARCH_MOBILE)
    },


	[VUEX_UI_SHOW_USER_FILTER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_USER_FILTER)
	},

	[VUEX_UI_HIDE_USER_FILTER]: ({ commit }) => {
		commit(VUEX_UI_HIDE_USER_FILTER)
	},

	[VUEX_UI_HIDE_JOB_SEARCH_MOBILE]: ({ commit }) => {
		commit(VUEX_UI_HIDE_JOB_SEARCH_MOBILE)
	},
	
	[VUEX_UI_SHOW_JOB_SEARCH_MOBILE]: ({ commit }) => {
		commit(VUEX_UI_SHOW_JOB_SEARCH_MOBILE)
	},

	[VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY)
	},

	[VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY)
	},

	[VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY]: ({ commit, dispatch }) => {
		commit(VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY)

        //GLOBAL ACTION PROMPT: Pass array of optional states to watch
        var stateChangeWatchers = [
            ['onboarding','emailResetEmail']
        ]
        dispatch('VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS', { stateChangeWatchers: stateChangeWatchers})
	},

	[VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY]: ({ commit }) => {
        //dispatch(VUEX_ONBOARDING_UPDATE_PROP_EMAIL_RESET, { email: ''})
		commit(VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY)
	},

	[VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE]: ({commit}, payload) => {
		commit(VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE, payload)
	},

	[VUEX_UI_NAV_CHILDREN_OPEN]: ({commit}, payload) => {
		commit(VUEX_UI_NAV_CHILDREN_OPEN, payload)
	},
	[VUEX_UI_SHOW_QUICK_FILTER_OVERLAY]: ({commit}) => {
		commit(VUEX_UI_SHOW_QUICK_FILTER_OVERLAY)
	},

	[VUEX_UI_HIDE_QUICK_FILTER_OVERLAY]: ({commit}) => {
		commit(VUEX_UI_HIDE_QUICK_FILTER_OVERLAY)
	},

	[VUEX_UI_SHOW_GLOBAL_UPLOADER]: ({ commit }) => {
		commit(VUEX_UI_SHOW_GLOBAL_UPLOADER)
	},

	[VUEX_UI_HIDE_GLOBAL_UPLOADER]: ({ state, commit }, delay) => {
		if (delay) {
			setTimeout(() => {
				if (state.globalUploader.openState) {
					commit(VUEX_UI_CLOSE_GLOBAL_UPLOADER)
				}
				commit(VUEX_UI_HIDE_GLOBAL_UPLOADER)
			}, delay)
		}  else {
			if (state.globalUploader.openState) {
				commit(VUEX_UI_CLOSE_GLOBAL_UPLOADER)
			}
			commit(VUEX_UI_HIDE_GLOBAL_UPLOADER)
		}
	},

	[VUEX_UI_OPEN_GLOBAL_UPLOADER]: ({ commit }, delay) => {
		if (delay) {
			setTimeout( commit(VUEX_UI_OPEN_GLOBAL_UPLOADER), delay)
		}  else {
			commit(VUEX_UI_OPEN_GLOBAL_UPLOADER)
		}
	},

	[VUEX_UI_CLOSE_GLOBAL_UPLOADER]: ({ commit }, delay) => {
		if (delay) {
			setTimeout( commit(VUEX_UI_CLOSE_GLOBAL_UPLOADER), delay)
		}  else {
			commit(VUEX_UI_CLOSE_GLOBAL_UPLOADER)
		}
	},

	[VUEX_UI_SHOW_JOB_PRINT_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_SHOW_JOB_PRINT_OVERLAY)
	},

	[VUEX_UI_HIDE_JOB_PRINT_OVERLAY]: ({ commit }) => {
		commit(VUEX_UI_HIDE_JOB_PRINT_OVERLAY)
	},
    [VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY]: ({commit}, payload) => {
        commit(VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY,payload)
    },


	[VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT]: ({ commit }) => {
		commit(VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT)
	},

}


const mutations = {

	[VUEX_UI_SHOW_NAVIGATION_DRAWER]: (state) => {
		state.navigationDrawer.openState = true
	},

	[VUEX_UI_HIDE_NAVIGATION_DRAWER]: (state) => {
		state.navigationDrawer.openState = false
	},

	[VUEX_UI_SHOW_LEFT_DRAWER]: (state) => {
		state.leftDrawer.openState = true
	},

	[VUEX_UI_HIDE_LEFT_DRAWER]: (state) => {
		state.leftDrawer.openState = false
	},

	[VUEX_UI_SHOW_RIGHT_DRAWER]: (state) => {
		state.rightDrawer.openState = true
	},

	[VUEX_UI_HIDE_RIGHT_DRAWER]: (state) => {
		state.rightDrawer.openState = false
		state.overlayMask.openState = false
	},

	[VUEX_UI_SHOW_EMAIL_ALL_OVERLAY]:(state) => {
		state.emailAllOverlay.openState = true
	},

	[VUEX_UI_HIDE_EMAIL_ALL_OVERLAY]:(state) => {
		state.emailAllOverlay.openState = false
	},

    [VUEX_UI_SHOW_ABSENCES_FILTER]: (state) => {
        state.absencesFilterOverlay.openState = true
    },

    [VUEX_UI_HIDE_ABSENCES_FILTER]: (state) => {
        state.absencesFilterOverlay.openState = false
    },

	[VUEX_UI_SHOW_JOB_FILTER]: (state) => {
		state.jobFilterOverlay.openState = true
	},

	[VUEX_UI_HIDE_JOB_FILTER]: (state) => {
		state.jobFilterOverlay.openState = false
	},

	[VUEX_UI_SHOW_JOB_SEARCH]: (state) => {
		state.jobSearchOverlay.openState = true
	},

	[VUEX_UI_HIDE_JOB_SEARCH]: (state) => {
		state.jobSearchOverlay.openState = false
	},

	[VUEX_UI_SHOW_JOB_CREATE]: (state) => {
		state.jobCreateOverlay.openState = true
	},

	[VUEX_UI_HIDE_JOB_CREATE]: (state) => {
		state.jobCreateOverlay.openState = false
	},

	[VUEX_UI_SHOW_OVERLAY]: (state) => {
		state.overlay.openState = true
	},

	[VUEX_UI_HIDE_OVERLAY]: (state) => {
		state.overlay.openState = false
	},

	[VUEX_UI_SHOW_REQUEST_ACCESS_OVERLAY]: (state) => {
		state.onboardingOverlay.openState = true
        state.onboardingOverlay.isRequestSuccessConfirmation = false
	},

	[VUEX_UI_HIDE_REQUEST_ACCESS_OVERLAY]: (state) => {
		state.onboardingOverlay.openState = false
        state.onboardingOverlay.isRequestSuccessConfirmation = false
	},

	[VUEX_UI_SHOW_USER_OVERLAY]: (state) => {
		state.userOverlay.openState = true
	},

	[VUEX_UI_HIDE_USER_OVERLAY]: (state) => {
		state.userOverlay.openState = false
	},

	[VUEX_UI_SHOW_USER_SEARCH]: (state) => {
		state.userSearchOverlay.openState = true
	},

	[VUEX_UI_HIDE_USER_SEARCH]: (state) => {
		state.userSearchOverlay.openState = false
	},


    [VUEX_UI_SHOW_USER_SEARCH_MOBILE]: (state) => {
        state.userSearchMobileOverlay.openState = true
    },

    [VUEX_UI_HIDE_USER_SEARCH_MOBILE]: (state) => {
        state.userSearchMobileOverlay.openState = false
    },



	[VUEX_UI_SHOW_USER_FILTER]: (state) => {
		state.userFilterOverlay.openState = true
	},

	[VUEX_UI_HIDE_USER_FILTER]: (state) => {
		state.userFilterOverlay.openState = false
	},

	[VUEX_UI_SHOW_RESET_PASSWORD_OVERLAY]:  (state) => {
		state.resetPasswordOverlay.openState = true
		state.isShowingConfirmation = false
	},

	[VUEX_UI_HIDE_RESET_PASSWORD_OVERLAY]:  (state) => {
		state.resetPasswordOverlay.openState = false
	},
		
	[VUEX_UI_HIDE_JOB_SEARCH_MOBILE]: (state) => {
		state.jobSearchMobileOverlay.openState = false
	},

		
	[VUEX_UI_SHOW_JOB_SEARCH_MOBILE]: (state) => {
		state.jobSearchMobileOverlay.openState = true
	},

	[VUEX_UI_SHOW_MOBILE_DRAWER_RIGHT]: (state) => {
		state.mobileDrawerRight.openState = true
	},

	[VUEX_UI_HIDE_MOBILE_DRAWER_RIGHT]: (state) => {
		state.mobileDrawerRight.openState = false
	},


	[VUEX_UI_HIDE_ALL]: (state) => {
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.resetPasswordOverlay.openState = false
		state.overlay.openState = false
		state.userOverlay.openState = false
		state.userFilterOverlay.openState = false
		state.userSearchOverlay.openState = false
		state.jobSearchMobileOverlay.openState = false
	},

	// ----------------------------
	// AUTH EVENTS
	// ----------------------------
	[VUEX_AUTH_LOGOUT]: (state) => {
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.overlay.openState = false
		state.resetPasswordOverlay.openState = false
		state.navigationDrawer.vuetifyDrawerState = false
		state.userOverlay.openState = false
		state.userFilterOverlay.openState = false
		state.userSearchOverlay.openState = false
	},

	// ----------------------------
	// JOB EVENTS
	// ----------------------------
	[VUEX_JOB_CREATE_UI]: (state) => {
		state.jobCreateOverlay.content = { path: 'ui/Jobs', file: 'Job_New' }
		state.jobCreateOverlay.openState = true
	},

	[VUEX_JOB_CREATE_CANCEL]: (state) => {
		state.jobCreateOverlay.openState = false
	},

	[VUEX_UI_SHOW_QUICK_FILTER_OVERLAY]: (state) => {
		state.quickFilterOverlay.openState = true
	},

	[VUEX_UI_HIDE_QUICK_FILTER_OVERLAY]: (state) => {
		state.quickFilterOverlay.openState = false
	},

	[VUEX_UI_SHOW_JOB_PRINT_OVERLAY]: (state) => {
		state.jobPrintOverlay.openState = true
        state.jobPrintOverlay.errorMessage = ''
	},

	[VUEX_UI_HIDE_JOB_PRINT_OVERLAY]: (state) => {
		state.jobPrintOverlay.openState = false
        state.jobPrintOverlay.errorMessage = ''
	},
    [VUEX_UI_SET_ERROR_JOB_PRINT_OVERLAY]: (state,payload ) => {
        state.jobPrintOverlay.errorMessage = payload
    },


	// ----------------------------
	// JOB ATTACHMENT: Open the job uploader
	// ----------------------------
	[VUEX_ATTACHMENT_QUEUE_MANAGER_INIT_JOB_ATTACHMENT]: (state, payload) => {
		state.overlay.options = payload ? payload : null
		state.overlay.content = { path: 'ui/Attachments/JobsUploadDialog', file: 'Attachments_Jobs_Dialog' }
		state.overlay.openState = true

        //APPCUES
        window.Appcues.track("Add Job File");
	},

	// ----------------------------
	// CALENDAR ITEM EVENTS
	// ----------------------------
	[VUEX_CALENDAR_ITEM_CREATE_INIT]: (state) => {
		state.calendarCreateOverlay.content = { path: 'ui/Organizations/CalendarItems', file: 'Calendar_Item_New' }
		state.calendarCreateOverlay.openState = true
	},

	// Mobile Drawer
	[VUEX_CALENDAR_ITEM_MOBILE_DRAWER_INIT]: (state) => {
		state.mobileDrawerRight.content = { path: 'ui/Organizations/Drawer', file: 'Calendar_Item_Drawer' }
		state.mobileDrawerRight.openState = true
	},


	[VUEX_CALENDAR_ITEM_CREATE_CANCEL]: (state) => {
		state.calendarCreateOverlay.openState = false
	},

	[VUEX_MEMO_ITEM_MOBILE_DRAWER_INIT]: (state) => {
		state.mobileDrawerRight.content = { path: 'ui/Organizations/Drawer', file: 'Memos_Drawer' }
		state.mobileDrawerRight.openState = true
	},



	// ----------------------------
	// MEMO EVENTS
	// ----------------------------
	[VUEX_MEMO_CREATE_INIT]: (state) => {
		state.memoCreateOverlay.content = { path: 'ui/Organizations/Memos', file: 'Memo_New' }
		state.memoCreateOverlay.openState = true
	},

	[VUEX_MEMO_CREATE_CANCEL]: (state) => {
		state.memoCreateOverlay.openState = false
	},

	// ----------------------------
	// DOC EVENTS
	// ----------------------------
	[VUEX_DOC_CREATE_INIT]: (state) => {
		state.docCreateOverlay.content = { path: 'ui/Organizations/Docs', file: 'Doc_New' }
		state.docCreateOverlay.openState = true
	},

	[VUEX_DOC_CREATE_CANCEL]: (state) => {
		state.docCreateOverlay.openState = false
	},


	// ----------------------------
	// ORGANIZATION EVENT EVENTS
	// ----------------------------
	[VUEX_EVENT_CREATE_INIT]: (state) => {
		state.eventCreateOverlay.content = { path: 'ui/Organizations/Events', file: 'Event_New' }
		state.eventCreateOverlay.openState = true
	},

	[VUEX_EVENT_CREATE_CANCEL]: (state) => {
		state.eventCreateOverlay.openState = false
	},


	// ----------------------------
	// ROUTING EVENTS
	// ----------------------------
	[VUEX_ROUTING_ENTER_UNAUTHENTICATED_ROUTE]: (state) => {
		state.navigationDrawer.vuetifyDrawerState = false
		state.leftDrawer.content = null
		state.rightDrawer.content = null
		state.resetPasswordOverlay.openState = false
	},

	[VUEX_ROUTING_ENTER_AUTHENTICATED_ROUTE]: (state) => {
		state.navigationDrawer.vuetifyDrawerState = true
		state.leftDrawer.content = { path: 'ui/Notifications', file: 'Notifications_Drawer' }
	},

	[VUEX_ROUTING_ENTER_JOBS]: (state) => {
		state.rightDrawer.content = { path: 'ui/Jobs/Drawer', file: 'Job_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
        state.rightDrawer.isFixed = false
		state.overlay.openState = false
		state.previewOpenStatusList = {}
	},

	[VUEX_ROUTING_ENTER_JOB]: (state) => {
		state.rightDrawer.content = { path: 'ui/Jobs/Drawer', file: 'Job_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = true
		state.rightDrawer.isFixed = true
		state.overlay.openState = false
		state.previewOpenStatusList = {}
	},

	[VUEX_ROUTING_EXIT_JOB]: (state) => {
        state.rightDrawer.openState = false
        state.rightDrawer.isFixed = false
		state.previewOpenStatusList = {}
	},
    [VUEX_ROUTING_EXIT_JOBS]: (state) => {

    },

	[VUEX_ROUTING_ENTER_REQUESTS]: (state) => {
		state.rightDrawer.content = { path: 'ui/Jobs/Drawer', file: 'Job_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.overlay.openState = false
	},


	[VUEX_ROUTING_ENTER_CALENDAR_ITEMS]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Calendar_Item_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.overlay.openState = false
	},

	[VUEX_ROUTING_ENTER_CALENDAR_ITEM]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Calendar_Item_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = true
		state.rightDrawer.isFixed = false
		state.overlay.openState = false
	},

	[VUEX_ROUTING_EXIT_CALENDAR_ITEM]: (state) => {
		state.rightDrawer.isFixed = false
	},

	[VUEX_ROUTING_ENTER_MEMOS]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Memos_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.overlay.openState = false
	},

	[VUEX_ROUTING_ENTER_MEMO]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Memos_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = true
		state.rightDrawer.isFixed = true
		state.overlay.openState = false
	},

	[VUEX_ROUTING_EXIT_MEMO]: (state) => {
		state.rightDrawer.isFixed = false
	},

	[VUEX_ROUTING_ENTER_DOCS]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Docs_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = false
		state.overlay.openState = false
	},

	[VUEX_ROUTING_ENTER_DOC]: (state) => {
		state.rightDrawer.content = { path: 'ui/Organizations/Drawer', file: 'Docs_Drawer' }
		state.navigationDrawer.openState = false
		state.notificationsDrawer.notificationSettingsOpenState = false
		state.leftDrawer.openState = false
		state.rightDrawer.openState = true
		state.rightDrawer.isFixed = true
		state.overlay.openState = false
	},

	[VUEX_ROUTING_EXIT_DOC]: (state) => {
		state.rightDrawer.isFixed = false
	},


	[VUEX_UI_SET_COMMENT_EDITOR_OPEN_STATE]: (state, payload) => {
		state.streamCommentEditor.openState = payload
	},

	// NAVBAR 
	[VUEX_UI_NAV_CHILDREN_OPEN]: (state, payload) => {
		if (state.mobileChild.childrenOpen == true && state.mobileChild.selected == payload){
			state.mobileChild.childrenOpen = false
			state.mobileChild.selected = null
			return
		} 
		if (state.mobileChild.childrenOpen == true &&  state.mobileChild.selected != payload ) {
			state.mobileChild.selected = payload
			return
		} else {
			state.mobileChild.selected = payload
			state.mobileChild.childrenOpen = true
			return
		}

	}, 

	[VUEX_UI_SHOW_GLOBAL_UPLOADER]: (state) => {
		state.globalUploader.displayState = true
	},

	[VUEX_UI_HIDE_GLOBAL_UPLOADER]: (state) => {
		state.globalUploader.displayState = false
	},

	[VUEX_UI_OPEN_GLOBAL_UPLOADER]: (state) => {
		state.globalUploader.openState = true
	},

	[VUEX_UI_CLOSE_GLOBAL_UPLOADER]: (state) => {
		state.globalUploader.openState = false
	},

	// Mutation: Set open status of a file previewer into an array so we can reopen on
	//           in-place updates
	[VUEX_UI_SET_PREVIEW_OPEN_STATUS]: (state, payload) => {
		state.previewOpenStatusList[payload.id] = payload.status
	},

	// Mutation: Unset all of the above, like when we nav into a job, etc
	[VUEX_UI_CLEAR_ALL_PREVIEW_OPEN_STATUSES]: (state) => {
		state.previewOpenStatusList = {}
	},

}

/**
 * The UI module of our Vuex store.
 * @module store/modules/ui
 */
export default {
  state,
  getters,
  actions,
  mutations,
}

